import React from 'react';
import { setDash, setNumberWithComma } from '../../../../lib/common';
import OpenProductDetail from '../../../../components/link/OpenProductDetail';
import OpenOrderItemDetail from '../../../../components/link/OpenOrderItemDetail';
import OpenUserDetail from '../../../../components/link/OpenUserDetail';
import { BALANCE_ITEM_TYPE_TEXT } from '../../../../constants/service/app/balanceConstants';
import { PAY_METHOD_TYPE_TEXT } from '../../../../constants/service/app/orderConstants';
import { PRODUCT_MANAGEMENT_TYPE_TEXT } from '../../../../constants/service/app/productConstants';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import { BRAND_TYPE_TEXT } from '../../../../constants/service/app/brandConstants';
import { setDateFormat } from '../../../../lib/moment';

/**
 *  정산 아이템 리스트 컬럼
 */
const columns = () => {
  return [
    {
      accessor: 'orderId',
      Header: '주문번호',
      width: 150,
    },
    {
      accessor: 'orderItemId',
      Header: '상품 주문번호',
      width: 150,
      Cell: (row) => <OpenOrderItemDetail text={row.value} orderItemId={row.value} />,
    },
    {
      accessor: 'type',
      Header: '구분',
      width: 150,
      Cell: (row) => BALANCE_ITEM_TYPE_TEXT[row.value] || '-',
    },
    {
      accessor: 'productId',
      Header: '상품번호',
      width: 150,
      Cell: (row) => <OpenProductDetail text={row.value} productId={row.value} />,
    },
    {
      accessor: 'pgName',
      Header: 'PG 사 정보',
      width: 100,
    },
    {
      accessor: 'payMethod',
      Header: '결제수단',
      width: 150,
      Cell: (row) => PAY_METHOD_TYPE_TEXT[row.value] || '-',
    },
    {
      accessor: 'userName',
      Header: '구매자명',
      width: 150,
      Cell: (row) => <OpenUserDetail text={row.value ? row.value : row.original.userId} userId={row.original.userId} />,
    },
    {
      accessor: 'balancePrice',
      Header: '정산금액',
      width: 150,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      Header: '판매금액',
      width: 150,
      Cell: (row) =>
        /**
         *  결제금액 + 쿠폰 금액 + 포인트 금액
         */
        setNumberWithComma(row.original.paidPrice + row.original.usedCouponPrice + row.original.usedPoint),
    },
    {
      accessor: 'usedCouponPrice',
      Header: '쿠폰',
      width: 150,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'usedPoint',
      Header: '포인트',
      width: 150,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'paidPrice',
      Header: '결제금액',
      width: 150,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'paymentDate',
      Header: '결제 일시',
      width: 140,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
    },
    {
      accessor: 'purchaseConfirmDate',
      Header: '구매 확정 일시',
      width: 140,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
    },
    {
      accessor: 'sumFee',
      Header: '수수료 합계',
      width: 150,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'management',
      Header: '관리처',
      width: 150,
      Cell: (row) => setDash(BRAND_TYPE_TEXT[row.value]),
    },
    {
      accessor: 'productManagementType',
      Header: '타입',
      width: 150,
      Cell: (row) => setDash(PRODUCT_MANAGEMENT_TYPE_TEXT[row.value]),
    },
    {
      accessor: 'pgFee',
      Header: 'PG 수수료',
      width: 150,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'amondzFee',
      Header: 'AMONDZ 수수료',
      width: 150,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'marketingFee',
      Header: '마케팅 수수료',
      width: 150,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'fulfillmentFee',
      Header: '풀필먼트 수수료',
      width: 150,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'pgFeeVat',
      Header: 'PG 수수료 VAT',
      width: 150,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'amondzFeeVat',
      Header: 'AMONDZ 수수료 VAT',
      width: 150,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'marketingFeeVat',
      Header: '마케팅 수수료 VAT',
      width: 150,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'fulfillmentFeeVat',
      Header: '풀필먼트 수수료 VAT',
      width: 150,
      Cell: (row) => setNumberWithComma(row.value),
    },
  ];
};

export default columns;
